(() => {
  const CHAT_SELECTOR = '#chat-04';
  const STYLE_ID = 'patch04-chat-style';

  const patchCss = `
    .empty-state__product-card,
    [class*="empty-state__product-card"] {
      position: relative !important;
      overflow: hidden !important;
      border: 5px solid #a8ae94 !important;
      border-radius: 3px !important;
      background:
        linear-gradient(115deg, rgba(82,105,54,.18), rgba(125,128,92,.12) 45%, rgba(74,96,62,.18)),
        #252a20 !important;
      color: #fff !important;
      box-shadow: 0 3px 7px rgba(23,32,18,.15) !important;
      transform-origin: center !important;
      padding: 0 !important;
      isolation: isolate !important;
    }

    .empty-state__product-card:nth-child(4n + 1) { transform: rotate(-2deg) !important; }
    .empty-state__product-card:nth-child(4n + 2) { transform: rotate(1.5deg) !important; }
    .empty-state__product-card:nth-child(4n + 3) { transform: rotate(1deg) !important; }
    .empty-state__product-card:nth-child(4n + 4) { transform: rotate(-1.5deg) !important; }

    .empty-state__product-card::before,
    [class*="empty-state__product-card"]::before {
      content: '' !important;
      position: absolute !important;
      inset: 0 !important;
      z-index: 3 !important;
      pointer-events: none !important;
      outline: 1px dashed rgba(255,255,255,.7) !important;
      outline-offset: -5px !important;
      border-radius: 2px !important;
      background:
        radial-gradient(ellipse 34% 18% at 0% 0%, rgba(82,105,54,.50), transparent 100%),
        radial-gradient(ellipse 17% 34% at 100% 28%, rgba(102,115,69,.38), transparent 100%),
        radial-gradient(ellipse 36% 17% at 100% 100%, rgba(74,96,62,.44), transparent 100%),
        radial-gradient(ellipse 14% 29% at 0% 78%, rgba(125,128,92,.32), transparent 100%) !important;
    }

    .empty-state__product-card::after,
    [class*="empty-state__product-card"]::after {
      content: '' !important;
      position: absolute !important;
      inset: 0 !important;
      z-index: 2 !important;
      pointer-events: none !important;
      background: linear-gradient(to top, rgba(0,0,0,.52), transparent 44%) !important;
    }

    .empty-state__product-card img,
    [class*="empty-state__product-card"] img {
      display: block !important;
      width: 100% !important;
      max-width: none !important;
      aspect-ratio: 1 / 1 !important;
      object-fit: cover !important;
      border: 0 !important;
      border-radius: 0 !important;
      position: relative !important;
      z-index: 1 !important;
    }

    .empty-state__product-card :is(
      [class*="title"],
      [class*="name"],
      [class*="label"],
      p,
      span
    ),
    [class*="empty-state__product-card"] :is(
      [class*="title"],
      [class*="name"],
      [class*="label"],
      p,
      span
    ) {
      color: #fff !important;
      position: relative !important;
      z-index: 4 !important;
      text-shadow: 0 1px 8px rgba(0,0,0,.3) !important;
    }

    .empty-state__product-card a,
    [class*="empty-state__product-card"] a {
      color: inherit !important;
      text-decoration: none !important;
    }
  `;

  const collectRoots = (root, out = []) => {
    if (!root) return out;
    out.push(root);
    const all = root.querySelectorAll?.('*') || [];
    for (const el of all) {
      if (el.shadowRoot) collectRoots(el.shadowRoot, out);
    }
    return out;
  };

  const injectIntoFrame = (frame) => {
    try {
      const doc = frame.contentDocument;
      if (!doc?.head) return false;

      let style = doc.getElementById(STYLE_ID);
      if (!style) {
        style = doc.createElement('style');
        style.id = STYLE_ID;
        style.textContent = patchCss;
        doc.head.appendChild(style);
      }

      doc.documentElement?.setAttribute('data-04-patch-chat', 'true');
      return true;
    } catch {
      return false;
    }
  };

  const scan = () => {
    const chat = document.querySelector(CHAT_SELECTOR);
    if (!chat) return;

    for (const root of collectRoots(chat)) {
      for (const frame of root.querySelectorAll?.('iframe') || []) {
        if (!frame.dataset.patch04Bound) {
          frame.dataset.patch04Bound = 'true';
          frame.addEventListener('load', () => injectIntoFrame(frame), { passive: true });
        }
        injectIntoFrame(frame);
      }
    }
  };

  let tries = 0;
  const timer = setInterval(() => {
    scan();
    tries += 1;
    if (tries > 120) clearInterval(timer);
  }, 500);

  const observer = new MutationObserver(scan);
  observer.observe(document.documentElement, { childList: true, subtree: true });

  document.addEventListener('shopify-chat:open', scan);
  window.addEventListener('pageshow', scan, { passive: true });
  scan();
})();